<template>
    <div class="project-swiper" ref="swiperBlock">
        <div class="swipers-content" :style="`width: ${100*contentNumber}vw; left: ${moveX}px; transform: translateX(${-100*contentIndex}vw);`" :class="moveType">  <!-- @touchstart="start" @touchmove="move" @touchend="end" -->
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: "sd-swiper",
    props: {
        num: Number,
        index: Number,
        scroll: Boolean,
        stop: Boolean
    },
    data() {
        return {
            contentIndex: this.index || 0,
            contentNumber: this.num || 0,
            startPageX: 0,
            moveX: 0,
            moveType: "",
            contentIsScroll: false,
            // noMove: this.stop || false,
            noMove: true,
        }
    },
    watch: {
        num(val) {
            this.contentNumber = val;
        },

        contentIndex(val) {
            this.$emit("update:index", val)
        },

        index(val) {
            this.contentIndex = val;
        },
        scroll(val) {
            this.contentIsScroll = val;
        },
        // stop() {
        //     this.noMove = !!this.stop;
        // }
    },
    mounted(){
        if(this.num) {
            this.setListener()
        }
    },
    methods: {
        start(e) {
            this.setMove(e, "start");
        },

        move(e) {
            this.setMove(e, "move");
        },

        end(e) {
            this.setMove(e, "end");
        },

        setMove(e, type) {
            let touch = e.changedTouches[0] || {}, pageX = touch.pageX;
            if(type == "start") {
                this.startPageX = pageX;
            }else if(type == "move") {
                if(this.contentIsScroll || this.noMove) this.startPageX = pageX;
                let moveX = pageX - this.startPageX;
                this.moveX = moveX;
            }else {
                if(this.contentIsScroll) {
                    this.contentIsScroll = false;
                    this.$emit("update:scroll", false)
                }
                if(this.moveX == 0) return;
                let px = this.$utils.px(this.moveX);
                if(px/375 >= 0.2) {
                    this.moveType = this.contentIndex == 0? 'keep' : 'up'
                }else if(px/375 <= -0.2) {
                    this.moveType = this.contentIndex == this.contentNumber-1? 'keep' : 'next'
                }else {
                    this.moveType = 'keep';
                }
                setTimeout(() => {
                    let keep = this.moveType == 'keep'
                    let isNext = this.moveType == 'next'? true : false;
                    this.moveX = 0
                    this.moveType = '';
                    if(!keep) {
                        if(isNext) {
                            this.contentIndex = this.contentIndex == this.contentNumber - 1? 0 : this.contentIndex+1;
                        }else {
                            this.contentIndex = this.contentIndex == 0? this.contentNumber - 1 : this.contentIndex-1;
                        }
                    }
                }, 500);
            }
        },

        setListener() {
            let swiperBlock = this.$refs.swiperBlock;
            let swiperContents = swiperBlock.getElementsByClassName("swiper-content");
            for(var i=0;i<swiperContents.length;i++) {
                let content = swiperContents[i];
                content.addEventListener('scroll',this.contentScroll)
            }
        },

        contentScroll() {
            this.contentIsScroll = true;
        }
    }
}
</script>

<style lang="scss" scoped>
.project-swiper {
    width: 100vw;
    height: 100%;
    overflow-x: hidden;

    .swipers-content {
        height: 100%;
        display: flex;
        position: relative;

        &.up {
            animation:moveup 0.5s ease-in-out;
            animation-fill-mode: forwards;
        }
        
        &.next {
            animation:movenext 0.5s ease-in-out;
            animation-fill-mode: forwards;
        }

        &.keep {
            animation:movekeep 0.5s ease-in-out;
            animation-fill-mode: forwards;
        }

        .swiper-content {
            width: 100vw;
            height: 100%;
            overflow: auto;
        }
    }
}

@keyframes moveup
{
    to {left:100vw;}
}
@keyframes movenext
{
    to {left:-100vw;}
}
@keyframes movekeep
{
    to {left:0vw;}
}
</style>


// WEBPACK FOOTER //
// src/components/common/swiperContent.vue